//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React, {Component} from 'react'
import Reflux from 'reflux'
import BankStore from '../../../store/bankstore'
import i18 from '../../../i18'
import api from '../../../source/api'
import bankactions from '../../../actions/bankactions'
import NotificationSystem from 'react-notification-system'
import utils from '../../../helpers/bankHelper'
import {Link} from 'react-router-dom'
import RowUnprocessed from './assignment/rowunprocessed'
import RowProcessed from './assignment/rowprocessed'
import Select from 'react-select'
import Modal from 'react-modal'


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        minHeight: '400px',
        maxWidth: '400px',
    }
}

const STEPS_COUNT = 4

class Assignment extends Reflux.Component {

    constructor(props) {
        super(props)
        this._notificationSystem = null
        this.state = {
            modalIsOpen: false,
            vszcompanies: [],
            partners: [],
            ruleBasedProcessed: [],
            currentItem: {},
            currentItemVSZcompany: 'UNKNOWN',
            showProcessedItemsTable: false,
            processedCount: 0,
            company_id: props.location.match.params.id,
            step: props.step,
            company: props.company
        }
        this.store = BankStore
    }

    closeModal = () => {
        this.setState({modalIsOpen: false})
    }

    _addNotification = (msg, type, time = 10) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    showProcessedItemsTable = () => {
        this.setState({showProcessedItemsTable: !this.state.showProcessedItemsTable})
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            step: nextProps.step,
            vszcompanies: this.buildPartnerSelect(),
            company: nextProps.company,
        })
    }

    buildPartnerSelect = () => {
        if (!this.state.bank.upload.vszcompanies.length) {
            return []
        }

        let selectArr = []
        let vszcompanies = this.state.bank.upload.vszcompanies

        vszcompanies.forEach((item) => {
            selectArr.push({value: item.formatted_name, label: item.name})
        })

        return selectArr
    }

    createRule = (event, invoice, type) => {
        let data = {
            company_id: this.state.company_id,
            company_name: invoice.companyName,
            item_name: invoice.typeOfTraffic,
            invoice_number: invoice.invoiceNumber,
            announcement: invoice.announcement,
            rule_type: event.target.attributes.name.nodeValue,
            main_bookkeeping_number: invoice.main_bookkeeping_number,
            legal_title: invoice.legal_title,
            sum_type: invoice.sum_type
        }
        api.post({url: 'bank/rule/add', data: data}, true).then((response) => {
            if (response.status === 201) {
                if (!Object.keys(this.state.bank.upload[type]).length) {
                    bankactions.setFlag(false, 'bank')
                } else {
                    this.updateInvoices(invoice, type)
                    this._addNotification('Szabály sikeresen mentve.', 'success')
                    this._addNotification(this.state.processedCount + ' db. sor sikeresen kontírozva.', 'success')
                }
            }
        }).catch((error) => {
            if (error.response.data === 'BOOK_KEEPING_NUMBER_TAKEN') {
                this._addNotification('Vevő/szallitora nem lehet szabályt alkotni! Kérem válasszon partnert vagy hagyja, függőn!', 'error', 30)
            } else {
                this._addNotification(error, 'error')
            }
        })
    }

    updateInvoices = (invoice, type) => {
        let processed = this.state.bank.upload.processed
        this.state.processedCount = 0
        let main_bookkeeping_number = invoice['main_bookkeeping_number']
        delete invoice['main_bookkeeping_number']
        let legal_title = invoice['legal_title']
        delete invoice['legal_title']
        let keys = Object.keys(invoice)
        if (!keys.length) {
            return false
        }
        let invoices = this.state.bank.upload[type]
        Object.keys(invoice).forEach((key) => (invoice[key] == null || !invoice[key].length) && delete invoice[key])

        for (let index in invoices) {
            let element = invoices[index]
            let match = 0

            for (let i in keys) {

                if (keys[i] == 'announcement' && (element.announcement !== null && element.announcement.length
                    && element.announcement.includes(invoice.announcement))) {
                    ++match
                }

                if (keys[i] == 'typeOfTraffic' && (element.typeOfTraffic !== null && element.typeOfTraffic.length
                    && element.typeOfTraffic.includes(invoice.typeOfTraffic))) {
                    ++match
                }

                if (keys[i] != 'announcement' && keys[i] != 'typeOfTraffic'
                    && element[keys[i]] == invoice[keys[i]]) {
                    ++match
                }

                if (keys[i] == 'sum_type' && element.sum !== null && (element.sum > 0 ? '+' : '-') == invoice[keys[i]]) {
                    ++match
                }

            }

            if (match == Object.keys(invoice).length) {
                if (!invoice.typeOfItem) {
                    element.main_bookkeeping_number = main_bookkeeping_number
                }
                if (!invoice.typeOfItem) {
                    element.legal_title = legal_title
                }

                ++this.state.processedCount
                invoices[index].type = 'RULE'
                invoices[index].typeOfItem = ''
                processed.push(invoices[index])
                delete invoices[index]
            }
        }


        this.state.showProcessedItemsTable = false
        this.state.bank.upload.processed = processed
        this.state.bank.upload[type] = invoices
        // todo: fix
        this.setState(this.state)
    }

    goToPairing = () => {
        this.state.step++
        if (this.state.step > STEPS_COUNT) return

        this.props.setBankState({
            dataUnprocessed: this.state.bank.upload.unprocessed
        });

        document.body.classList.toggle('loading-body', true)
        setTimeout(() => {
            document.body.classList.remove('loading-body')
            this.props.setNextStep()
        }, 2500)
    }

    listUnProcessedInvoices = () => {
        let invoices = []
        if (Object.keys(this.state.bank.upload.unprocessed).length) {
            for (let index in this.state.bank.upload.unprocessed) {
                let element = this.state.bank.upload.unprocessed[index]
                invoices.push(<RowUnprocessed
                    type='unprocessed'
                    _addNotification={(msg, type, time) => this._addNotification(msg, type, time)}
                    key={index}
                    bank={this.state.bank}
                    onShowModal={(item) => this.onShowModal(item)}
                    onConfirmAutoMatching={(item) => this.confirmAutoMatching(item)}
                    onSetProcessedItemsFlag={() => this.onSetProcessedItemsFlag()}
                    onCreateRule={(event, invoice, type) => this.createRule(event, invoice, type)}
                    keyIndex={index}
                    invoice={element}/>)
            }
        }
        return invoices.length ? invoices : (
            <tr>
                <td colSpan={this.state.company && this.state.company.accountant_program_id === 2 ? 10 : 9}>
                    <h4 className='text-center'>Minden tétel sikeresen kontírozásra került.</h4>
                </td>
            </tr>
        )
    }

    onSetProcessedItemsFlag = () => {
        this.setState({showProcessedItemsTable: true});
    }

    onSetTypeOfCurrentItem = (event) => {
        if (event.target.value) {
            let currentItem = this.state.currentItem;
            currentItem.typeOfItem = event.target.value;
            this.setState({currentItem: currentItem})
        }
    }

    onSetCurrentItemCompany = (item) => {
        if (item.value) {
            let currentItem = this.state.currentItem;

            currentItem.companyNameFromBank = currentItem.companyName;
            currentItem.companyName = item.label;
            currentItem.company_name_formatted = item.value;

            this.setState({
                currentItem: currentItem,
                currentItemVSZcompany: item.value
            })
        }
    }

    confirmAutoMatching = (item) => {

        item.type = 'PARTNER_VSZ';
        item.typeOfItem = 'PARTNER_VSZ';
        item.id = item.id + 'PARTNER_VSZ';
        item.main_bookkeeping_number = '';
        item.legal_title = '';

        const unprocessed = this.state.bank.upload.unprocessed;
        let processed = this.state.bank.upload.processed;
        if (Object.keys(unprocessed).length) {
            const resultUnprocessed = unprocessed.filter(function (i) {
                return i.row_nb !== item.row_nb
                    && i.companyName.toLowerCase().indexOf(
                        item.companyNameFromBank
                            ? item.companyNameFromBank.toLowerCase()
                            : item.companyName.toLowerCase()
                    ) === -1;
            });
            const resultProcessed = unprocessed.filter(function (i) {
                return i.row_nb === item.row_nb
                    || i.companyName.toLowerCase().indexOf(
                        item.companyNameFromBank
                            ? item.companyNameFromBank.toLowerCase()
                            : item.companyName.toLowerCase()
                    ) === 0;
            });

            bankactions.setUnprocessed(resultUnprocessed);
            const originalCompanyName = item.companyName;
            if (resultProcessed.length) {
                resultProcessed.forEach((invoice) => {
                    invoice.main_bookkeeping_number = item.main_bookkeeping_number;
                    invoice.legal_title = item.legal_title;
                    invoice.typeOfItem = item.typeOfItem;
                    invoice.companyName = item.company_name_offered;
                    invoice.company_name_formatted = item.company_name_offered_formatted;
                    processed.push(invoice)
                })
            }

            bankactions.setProcessed(processed);


            item.companyName = originalCompanyName;
            api.post({url: 'bank/index/savevsz', data: {item, company_id: this.state.company_id}}, true).then(() => {
                this.setState({
                    showProcessedItemsTable: false,
                    modalIsOpen: false
                });
                this._addNotification('V/SZ beállítása sikeres. A kiválasztott tétel átkerült a feldolgozott "tételek listába".', 'success')
            }).catch(() => {
                this._addNotification('V/SZ mentése sikertelen.', 'error')
            })
        }
    }

    updateStatementItem = () => {

        if (!this.state.currentItemVSZcompany) {
            this._addNotification('Sikertelen mentés: Partner és vevő/szállító kiválasztva kötelező, különben ismeretlen tételként könyvelődik.', 'error')
            return;
        }

        let item = this.state.currentItem;

        const unprocessed = this.state.bank.upload.unprocessed;
        let processed = this.state.bank.upload.processed;

        if (Object.keys(unprocessed).length) {

            const resultUnprocessed = unprocessed.filter(function (i) {
                return i.row_nb !== item.row_nb
                    && i.companyName.toLowerCase().indexOf(
                        item.companyNameFromBank
                            ? item.companyNameFromBank.toLowerCase()
                            : item.companyName.toLowerCase()
                    ) === -1;
            });

            const resultProcessed = unprocessed.filter(function (i) {
                return i.row_nb === item.row_nb
                    || i.companyName.toLowerCase().indexOf(
                        item.companyNameFromBank
                            ? item.companyNameFromBank.toLowerCase()
                            : item.companyName.toLowerCase()
                    ) === 0;
            });

            bankactions.setUnprocessed(resultUnprocessed);
            item.company_name_offered_formatted = this.state.currentItemVSZcompany;
            item.company_name_offered = item.companyName;

            if (resultProcessed.length) {
                resultProcessed.forEach((invoice) => {
                    invoice.main_bookkeeping_number = item.main_bookkeeping_number;
                    invoice.legal_title = item.legal_title;
                    invoice.companyName = item.companyName;
                    invoice.company_name_formatted = item.company_name_offered_formatted;
                    invoice.type = 'PARTNER_VSZ';
                    invoice.typeOfItem = 'PARTNER_VSZ';
                    invoice.id += 'PARTNER_VSZ';
                    invoice.main_bookkeeping_number = '';
                    invoice.legal_title = '';

                    processed.push(invoice)
                })
            }

            bankactions.setProcessed(processed)

            this.state.showProcessedItemsTable = false
            this.state.modalIsOpen = false

            api.post({
                url: 'bank/index/savevsz', data: {
                    item,
                    company_id: this.state.company_id
                }
            }, true).then(() => {
                this.setState(this.state)
                this._addNotification('V/SZ beállítása sikeres. A kiválasztott tétel átkerült a feldolgozott "tételek listába".', 'success')
            }).catch(() => {
                this._addNotification('V/SZ mentése sikertelen.', 'error')
            })

        }
    }

    onShowModal = item => {
        this.setState({currentItemVSZcompany: 'UNKNOWN'})
        this.setState({currentItem: item})
        this.setState({modalIsOpen: true})
    }

    listProcessedInvoices = () => {
        let invoices = []
        if (Object.keys(this.state.bank.upload.processed).length) {
            for (let index in this.state.bank.upload.processed) {
                let element = this.state.bank.upload.processed[index]
                invoices.push(<RowProcessed
                    type='processed'
                    bank={this.state.bank}
                    _addNotification={(msg, type, time) => this._addNotification(msg, type, time)}
                    key={index}
                    onCreateRule={(event, invoice, type) => this.createRule(event, invoice, type)}
                    keyIndex={index}
                    invoice={element}/>)
            }
        }

        return invoices.length ? invoices : (
            <tr>
                <td colSpan={this.state.company && this.state.company.accountant_program_id === 2 ? 10 : 9}>
                    <h4 className='text-center'>Nincsenek feldolgozott tételek.</h4>
                </td>
            </tr>
        )
    }

    render() {
        const {selectedOption} = typeof this.state.currentItemVSZcompany !== 'undefined' ? this.state.currentItemVSZcompany : 'UNKNOWN'
        return (
            <section id='bank-assignment'>
                <div className="row">
                    <div className='col-md-6'>
                        <ul className='legend padding-left-15'>
                            <li>
                                <h4 className='text-left'>Kiválasztott cég: {typeof this.state.bank.upload.company !== 'undefined' ? this.state.bank.upload.company.name : ''} (<Link className='link-color' to='/'>cég csere</Link>)</h4>
                            </li>
                        </ul>
                    </div>
                    <div className='col-md-6'>
                        <ul className='legend'>
                            <li><i className='fa fa-dot-circle-o' aria-hidden='true'></i> <span className=''>{i18.CUSTOMER._createRulesAndProcess}</span></li>
                            <li><i className='padding-left-20 fa fa-check-circle' aria-hidden='true'></i> <span className=''>{i18.CUSTOMER._oneTimeProcessing}</span></li>
                        </ul>
                    </div>
                </div>
                <div className="">
                    <div className='col-md-12'>
                        <table className="table table-striped  table-aibook-no-border">
                            <thead>
                            <tr>
                                <th>{i18.BANK._typeOfTraffic}</th>
                                <th>{i18.BANK._day}</th>
                                <th>{i18.BANK._sum}</th>
                                <th>{i18.BANK._invoiceNumber}</th>
                                <th>{i18.BANK._companyName}</th>
                                <th>{i18.BANK._announcement}</th>
                                <th>{i18.BANK._v_sz}</th>
                                <th>{i18.BANK._mainBookNumber}</th>
                                {this.state.company && this.state.company.accountant_program_id === 2 ? <th>{i18.BANK._legalTitle}</th> : null}
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.listUnProcessedInvoices()}
                            </tbody>
                        </table>
                    </div>

                    <div className='col-12 padding-bottom-40'>
                        <a onClick={() => this.showProcessedItemsTable()} className="pull-left next-step">
                            {this.state.showProcessedItemsTable ? i18.BUTTONS._hideProcessedItems : i18.BUTTONS._showProcessedItems}
                        </a>
                        <a onClick={() => this.goToPairing()} className="pull-right next-step">
                            {i18.BUTTONS._goToPairing}
                        </a>
                    </div>
                    <div className={this.state.showProcessedItemsTable ? 'col-md-12' : 'd-none'}>
                        <table className="table table-striped  table-aibook-no-border">
                            <thead>
                            <tr>
                                <th>{i18.BANK._typeOfTraffic}</th>
                                <th>{i18.BANK._day}</th>
                                <th>{i18.BANK._sum}</th>
                                <th>{i18.BANK._invoiceNumber}</th>
                                <th>{i18.BANK._companyName}</th>
                                <th>{i18.BANK._announcement}</th>
                                <th>{i18.BANK._v_sz}</th>
                                <th>{i18.BANK._mainBookNumber}</th>
                                {this.state.company && this.state.company.accountant_program_id === 2 ? <th>{i18.BANK._legalTitle}</th> : null}
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.listProcessedInvoices()}
                            </tbody>
                        </table>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                </div>

                <NotificationSystem ref='notificationSystem'/>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={() => this.closeModal()}
                    style={customStyles}
                    contentLabel='Szabály szerkesztése'>
                    <h5 className='text-center'>Ismeretlen banki tétel besorolása</h5>
                    <p className='hint'>
                        Tétel partner: <b>{this.state.currentItem.companyName}</b><br/>
                        Tétel megnevezés: <b>{this.state.currentItem.typeOfTraffic}</b><br/>
                        Tétel összeg: <b>{this.state.currentItem.sum} {this.state.currentItem.currency}</b><br/>
                    </p>
                    <Select
                        value={selectedOption}
                        placeholder='Kérjük válassza ki a partner céget'
                        isMulti={false}
                        onChange={this.onSetCurrentItemCompany}
                        options={this.state.vszcompanies}
                    />
                    <br/>
                    <div className='text-center'>
                        <a onClick={() => this.updateStatementItem()}
                           className='next-step'>Mentés</a>
                        <p className='hint'>
                            Ha nincs partner és vevő vagy szállító kiválasztva, ez a tétel ismeretlenként fog bekerülni a kimeneti xml-be
                        </p>
                    </div>
                </Modal>
            </section>
        )
    }
}

export default Assignment


// WEBPACK FOOTER //
// ./src/components/bank/steps/assignment.js